var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThrdHelicopter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "helicopter_x2C__bomb_x2C__airplane_x2C__fighter_x2C__intercepter_x2C__jet_plane",
    style: {},
    transform: "matrix(1.174117, 0, 0, 1.174117, -44.396633, -44.572769)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259.031,467.729l7.666-42.879h42.861l6.497,2.764l-5.244-19.129h-42.88l0.76-22.097h40.867V370.16    h-40.321l2.491-71.319l18.778-63.041l109.715,105.785v-15.329L292.994,214.331l42.88-6.352V185.4L294.3,167.52L400.222,58.151    V44.754l-1.313-0.69L292.994,147.427l-8.775-59.309h-7.661c0,0-12.352-30.241-21.615-30.241c-9.243,0-21.603,30.241-21.603,30.241    h-7.601l-8.757,59.309L111.476,44.546v15.4L215.658,167.52L174.102,185.4v22.579l42.879,6.352L111.476,324.457v15.464    L219.391,235.8l18.857,63.041l2.615,71.319h-41.492v16.228h42.12l0.827,22.234h-42.947l-5.185,19.197l6.49-2.765h42.951    l7.59,42.88L259.031,467.729z",
    style: {
      strokeMiterlimit: 23.75,
      paintOrder: "stroke",
      strokeWidth: "6.81363px",
      stroke: "rgb(255, 255, 255)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrdHelicopter);
export default __webpack_public_path__ + "static/media/thrd-helicopter.f73f84628120cec67702933c5535282b.svg";
export { ForwardRef as ReactComponent };